import { environment } from '../../../environments/environment';

export function triggerHotJarGa(triggerName: string, eventCategory = 'Performance Reports') {
  if (!environment.enableAnalytics || triggerName == null) {
    return;
  }

  window['hj']('trigger', triggerName);
  window['hj']('tagRecording', [triggerName]);
  window['gtag']('send', {
    hitType: 'event',
    eventCategory,
    eventAction: 'filter',
    eventLabel: triggerName});
}
